var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"bo-admin-import-main"}},[_c('bo-import',{attrs:{"title":"Import de nouveaux utilisateurs","subtitle":"Back Office","columns":_vm.columns,"routePrefix":"users","storePrefix":"bouser"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }